import { animate, state, style, transition, trigger } from '@angular/animations';

export const stickyAnimation = trigger('stickyAnimation', [
  // ✅ ENTER – slide IN from bottom
  transition(':enter', [
    style({
      transform: 'translateY(100%)',
      opacity: 0,
    }),
    animate(
      '600ms cubic-bezier(0.22, 1, 0.36, 1)',
      style({
        transform: 'translateY(0)',
        opacity: 1,
      })
    ),
  ]),

  // ✅ EXIT – slide OUT to TOP (LENTO)
  transition('large <=> small', [animate('300ms ease-out')]),
]);

export const slideInFromBottom = trigger('slideInFromBottom', [
  transition(':enter', [
    style({
      transform: 'translateY(100%)',
      opacity: 0,
    }),

    animate(
      '1000ms ease-out',
      style({
        transform: 'translateY(0)',
        opacity: 1,
      })
    ),
  ]),
]);

export const bannerResizeAnimation = trigger('bannerResize', [
  state(
    'large',
    style({
      height: '135px',
    })
  ),

  state(
    'small',
    style({
      height: '80px',
    })
  ),
  /*  state('section', style({
     height: '335px',
   })), */
  state(
    'small-mobile',
    style({
      height: '265px;',
    })
  ),
  state(
    'large-mobile',
    style({
      height: '95px;',
    })
  ),

  transition('large <=> small', [animate('350ms cubic-bezier(0.22, 1, 0.36, 1)')]),
]);
